import { render, staticRenderFns } from "./HideChannels.vue?vue&type=template&id=12dbd31c&scoped=true"
import script from "./HideChannels.vue?vue&type=script&lang=js"
export * from "./HideChannels.vue?vue&type=script&lang=js"
import style0 from "./HideChannels.vue?vue&type=style&index=0&id=12dbd31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbd31c",
  null
  
)

export default component.exports